import { motion } from "framer-motion";

const values = [
  {
    icon: "/photos/Icon1.png",
    title: "Cutting-Edge Innovation",
    desc: "Continuously developing new and innovative software solutions to stay ahead of the competition and meet evolving customer needs.",
  },
  {
    icon: "/photos/Icon2.png",
    title: "Agility",
    desc: "Adapting quickly to changes in technology, market trends, and customer preferences to remain competitive and seize new opportunities.",
  },
  {
    icon: "/photos/Icon3.png",
    title: "Talent Development",
    desc: "Investing in recruiting and retaining top talent, providing ongoing training to ensure a skilled and motivated workforce.",
  },
];

export default function StrategicValues() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 max-w-7xl mx-auto text-center relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[#007BFF]/10 blur-[100px] md:blur-[140px] -z-10" />

      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-16 md:mb-24">
        <span className="inline-block px-4 md:px-5 py-2 rounded-full text-[10px] font-black bg-gradient-to-r from-[#007BFF] to-[#05DFAD] text-white uppercase tracking-[0.2em] md:tracking-[0.3em] mb-5 md:mb-7 shadow-lg shadow-blue-500/20">
          Core Principles
        </span>

        <h2 className="text-3xl sm:text-4xl md:text-6xl font-black mb-6 md:mb-8 text-white leading-tight tracking-tighter italic uppercase px-2">
          Our{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#007BFF] to-[#05DFAD]">
            Strategic Values
          </span>
        </h2>

        <p className="text-slate-400 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed font-medium px-2">
          We prioritize leveraging technology innovation, agile methodologies,
          and talent development to build products that redefine market
          standards.
        </p>
      </motion.div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-14 relative">
        {values.map((value, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.15, duration: 0.7 }}
            viewport={{ once: true }}
            className="group relative p-7 md:p-10 rounded-[24px] md:rounded-[38px] bg-[#161B22]/40 backdrop-blur-2xl border border-white/5 hover:border-emerald-400/30 transition-all duration-700">
            <span className="absolute top-4 md:top-6 right-6 md:right-8 text-6xl md:text-8xl font-black text-white/[0.03] italic group-hover:text-[#05DFAD]/10 transition-colors duration-700">
              0{idx + 1}
            </span>

            <div className="absolute inset-0 bg-gradient-to-br from-[#007BFF]/10 via-transparent to-[#05DFAD]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-[24px] md:rounded-[38px]" />

            <div className="relative z-10 text-start">
              <div className="w-14 h-14 md:w-16 md:h-16 mb-7 md:mb-9 rounded-xl md:rounded-2xl bg-[#0B0F19] flex items-center justify-center border border-white/10 shadow-inner group-hover:shadow-[0_0_20px_rgba(0,123,255,0.3)] transition-all duration-500">
                <img
                  src={value.icon}
                  alt={value.title}
                  className="w-7 h-7 md:w-8 md:h-8 object-contain brightness-125"
                />
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-5 group-hover:translate-x-1 transition-transform duration-500">
                {value.title}
              </h3>

              <div className="w-12 h-1 bg-gradient-to-r from-[#007BFF] to-[#05DFAD] mb-5 md:mb-7 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500" />

              <p className="text-slate-400 leading-8 text-sm md:text-base font-normal">
                {value.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
